// extracted by mini-css-extract-plugin
export default {"container":"Ud9E4P","title":"Vfbk15","text":"dFqExG"};